<template>
	<div class="captcha-container">
		<!-- 验证码画布 -->

		<!-- 输入框和按钮 -->
		<input v-model="userInput" type="text" placeholder="请输入验证码" class="captcha-input" />
		<canvas ref="captchaCanvas" @click="refreshCaptcha" width="120" height="40" style=" cursor: pointer;"></canvas>
		<!-- <button @click="validate" class="captcha-btn">验证</button> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				captchaText: '', // 存储生成的验证码
				userInput: '' // 用户输入内容
			};
		},
		mounted() {
			this.generateCaptcha();
		},
		methods: {
			// 生成随机验证码文本
			generateText() {
				const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // 去除了容易混淆的字符
				let text = '';
				for (let i = 0; i < 4; i++) {
					text += chars.charAt(Math.floor(Math.random() * chars.length));
				}
				return text;
			},

			// 绘制验证码
			generateCaptcha() {
				const canvas = this.$refs.captchaCanvas;
				const ctx = canvas.getContext('2d');

				// 清空画布
				ctx.clearRect(0, 0, canvas.width, canvas.height);

				// 生成新验证码
				this.captchaText = this.generateText();

				// 绘制背景
				ctx.fillStyle = '#f5f5f5';
				ctx.fillRect(0, 0, canvas.width, canvas.height);

				// 绘制文字
				for (let i = 0; i < this.captchaText.length; i++) {
					ctx.save();
					ctx.font = '24px Arial';
					ctx.fillStyle = this.getRandomColor();
					ctx.translate(20 + i * 25, 25);
					ctx.rotate((Math.random() - 0.5) * 0.4); // 随机旋转
					ctx.fillText(this.captchaText[i], 0, 0);
					ctx.restore();
				}

				// 绘制干扰线
				for (let i = 0; i < 10; i++) {
					ctx.beginPath();
					ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
					ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
					ctx.strokeStyle = this.getRandomColor();
					ctx.lineWidth = 1;
					ctx.stroke();
				}
			},

			// 获取随机颜色
			getRandomColor() {
				return `rgb(${[
					Math.floor(Math.random() * 156) + 50, // 避免颜色太深
					Math.floor(Math.random() * 156) + 50,
					Math.floor(Math.random() * 156) + 50
				].join(',')})`;
			},

			// 点击刷新验证码
			refreshCaptcha() {
				this.generateCaptcha();
			},

			// 验证用户输入
			validate() {
				const isValid = this.userInput.toUpperCase() === this.captchaText.toUpperCase();
				if(!isValid){
					this.$toast('验证失败，请重试');
				}
				if (!isValid) {
					this.userInput = '';
					this.generateCaptcha();
				}
				this.$emit('validated', isValid);
			}
		}
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.captcha-container {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		// border: 1*@vm_base solid red;
		border-radius: 8*@vm_base;
	}

	.captcha-input {
		width: calc(100% - 120px);
		// padding: 8px;
		border: none;
		outline: none;
		border-radius: 4px;
	}

	.captcha-btn {
		padding: 8px 16px;
		background: #409eff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/Captcha.vue